import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TokenStorageService } from '@app/_services/token-storage.service';
import {RedirectUrlService} from '@app/_services/redirect-url.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(
    private router: Router,
    private tokenStorageService: TokenStorageService,
    private redirectUrlService: RedirectUrlService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const token = this.tokenStorageService.getToken();
    const redirectObject$ = this.redirectUrlService.configObject$;
    if (!redirectObject$.value){
      const arr = await this.redirectUrlService.fetchRedirectUrl();
    }
    if (token != null) {
      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.redirectUrlService.logoutRedirect(state);
    return false;
  }
}
